interface GeoJsonPreviewProps {
  geojson: unknown | null;
  onClose: () => void;
}

export default function GeoJsonPreview({ geojson, onClose }: GeoJsonPreviewProps) {
  if (!geojson) return null;

  const text = JSON.stringify(geojson, null, 2);

  const download = () => {
    const blob = new Blob([text], { type: "application/geo+json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `editor-territorial-${Date.now()}.geojson`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-40" onClick={onClose} />
      <div className="fixed right-0 top-0 bottom-0 w-full max-w-xl bg-white z-50 shadow-xl flex flex-col">
        <div className="p-4 border-b border-background-100 flex items-center justify-between">
          <h2 className="text-sm font-semibold text-foreground-900">Exportação GeoJSON</h2>
          <div className="flex items-center gap-2">
            <button
              onClick={() => navigator.clipboard.writeText(text)}
              className="text-xs px-2.5 py-1.5 rounded-md border border-background-200 hover:bg-background-50 cursor-pointer"
            >
              Copiar
            </button>
            <button
              onClick={download}
              className="text-xs px-2.5 py-1.5 rounded-md bg-primary-500 text-white hover:bg-primary-600 cursor-pointer"
            >
              Baixar
            </button>
            <button onClick={onClose} className="w-7 h-7 rounded-md hover:bg-background-100 flex items-center justify-center cursor-pointer">
              <i className="ri-close-line text-foreground-500" />
            </button>
          </div>
        </div>
        <pre className="flex-1 overflow-auto p-4 text-[11px] font-mono text-foreground-700 whitespace-pre-wrap">{text}</pre>
      </div>
    </>
  );
}
